package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.EncodeDefault
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import com.schoolconnect.app.repository.systemlookup.SystemLookupOptions

@Serializable
data class ParentWrapperData(
    val name: String,
    val mobile: String,
    val email: String? = null,
    @SerialName("custom_attributes")
    val customAttributes: Map<String, String> = emptyMap(),
    @EncodeDefault
    @SerialName("is_active")
    val isActive: Boolean = true
)

@Serializable
data class StudentParentWrapperCreateRequest(
    @SerialName("student_id")
    val studentId: String,
    @SerialName("primary_parent")
    val primaryParent: ParentWrapperData,
    @SerialName("secondary_parent")
    val secondaryParent: ParentWrapperData? = null,
    @SerialName("primary_relationship_type")
    val primaryRelationshipType: String = SystemLookupOptions.codes("PARENT_RELATIONSHIP").getOrNull(0).orEmpty(),
    @SerialName("secondary_relationship_type")
    val secondaryRelationshipType: String = SystemLookupOptions.codes("PARENT_RELATIONSHIP").getOrNull(1).orEmpty(),
    @SerialName("primary_is_primary_contact")
    val primaryIsPrimaryContact: Boolean = true,
    @SerialName("secondary_is_primary_contact")
    val secondaryIsPrimaryContact: Boolean = false
)

@Serializable
data class ParentCreateRequest(
    @SerialName("school_id") val schoolId: String,
    val name: String,
    @SerialName("custom_attributes") val customAttributes: Map<String, String> = emptyMap(),
    @EncodeDefault
    @SerialName("is_active") val isActive: Boolean = true,
    val mobile: String,
    val email: String? = null
)

@Serializable
data class StudentParentLinkCreateRequest(
    @SerialName("student_id") val studentId: String,
    @SerialName("parent_id") val parentId: String,
    @SerialName("relationship_type") val relationshipType: String,
    @SerialName("is_primary_contact") val isPrimaryContact: Boolean = false,
    @EncodeDefault
    @SerialName("is_active") val isActive: Boolean = true
)

@Serializable
data class StudentParentLinkUpdateRequest(
    @SerialName("student_id") val studentId: String? = null,
    @SerialName("parent_id") val parentId: String? = null,
    @SerialName("relationship_type") val relationshipType: String? = null,
    @SerialName("is_primary_contact") val isPrimaryContact: Boolean? = null,
    @SerialName("is_active") val isActive: Boolean? = null
)

@Serializable
data class ParentUpdateRequest(
    @SerialName("school_id") val schoolId: String? = null,
    @SerialName("user_id") val userId: String? = null,
    val name: String? = null,
    val mobile: String? = null,
    val email: String? = null,
    @SerialName("custom_attributes") val customAttributes: Map<String, String>? = null,
    @SerialName("is_active") val isActive: Boolean? = null,
    @SerialName("push_notification_enabled") val pushNotificationEnabled: Boolean? = null,
    @SerialName("email_notification_enabled") val emailNotificationEnabled: Boolean? = null,
    @SerialName("profile_image_file_id") val profileImageFileId: String? = null
)
